import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import User from '../menu/user';
import Comment from '../newsline/comment';
import Like from '../newsline/like';


class Post extends Component {

    constructor(props) {
        super(props);
        this.props = props
        this.state = {
            showImageModal: false,
            showComments: false
        }
    }

    render() {
        var item = this.props.item
        return (
            <div className="post">
                <div className="comment-button-wrapper">
                    {item.user_id == localStorage.getItem('user_id') && <button className="edit-button" onClick={() => { this.handleEditPost(item.id) }}>
                        <img alt="Edit" src={require("../../images/edit-icon.svg")} />
                    </button>}
                    {item.user_id == localStorage.getItem('user_id') && <button className="delete-button" onClick={() => {
                        const { deletePost } = this.props

                        deletePost(item.id)
                    }}>
                        <img alt="Delete" src={require("../../images/delete-icon.svg")} />
                    </button>}
                </div>
                <div className="post-header">
                    <User {...this.props} user_id={item.user_id} />
                </div>
                <div className="post-wrapper">
                    <div className="post-content">
                        {item.photo && <img className="image-content" alt="Preview Image Unavailable" src={item.photo} />}
                        {item.link_url && <ReactPlayer height="auto" width="100%" url={item.link_url} />}
                        <span className="post-message">{item.text}</span>
                    </div>
                    <div className="likes-container">
                        <Like {...this.props} post_id={item.id} />
                        <div className="post-options">
                            <button onClick={() => { this.handleShowComments() }}>Comments</button>
                            <button>Share</button>
                        </div>
                    </div>
                </div>
                {this.state.showComments &&
                    <div>
                        {/* should place comment component */}
                        <Comment {...this.props} lkm={this} post_id={item.id} />
                        {/* should place like component */}
                    </div>
                }
            </div>
        )
    }

    handleEditPost(id) {
        this.props.doUpdatePost(id)
    }

    handleShowComments = () => {
        this.setState({ showComments: !this.state.showComments })
    }
}
Post.propTypes = {
    history: PropTypes.object,
    deletePost: PropTypes.func,
    doUpdatePost: PropTypes.func,
    item: PropTypes.object
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/newsline/post.js